import dayjs from "dayjs"
import { useMemo } from "react"
import {
  useGraphContext,
  xAxisHeight,
  timeDividerWidth,
} from "../GraphContext"
import { TimeDivider } from "./TimeDivider"
import styles from "./TimeDividers.module.scss"
import { useDisplayDividerTime } from "./useDisplayDividerTime"

interface Props {
  start: string;
  timeDividers: string[];
  /*
   * ISO time of a divider whose label should be hidden because it would
   * overlap the now line's time label.
   */
  suppressLabelForTime?: string;
}

export function TimeDividers(props: Props) {
  const {
    start,
    timeDividers,
    suppressLabelForTime,
  } = props

  const {
    pointsPerHour,
    dividersPerTimeLabel,
  } = useGraphContext()

  const displayTime = useDisplayDividerTime()

  const computedStyles = useMemo(
    () => ({
      width: timeDividerWidth,
      transform: `translateX(${timeDividerWidth / -2}px)`,
      bottom: xAxisHeight,
    }),
    [],
  )

  return (
    <>
      {
        timeDividers.map((time: string, index: number) => (
          <div
            key={time}
            className={styles.container}
            style={{
              ...computedStyles,
              left: dayjs(time).diff(
                start,
                "hours",
                true,
              ) * pointsPerHour,
            }}
          >
            <TimeDivider />
            {index % dividersPerTimeLabel !== 0 || time === suppressLabelForTime ? null : (
              <div
                className={styles.text}
                id="time-label-text"
              >
                {displayTime(time)}
              </div>
            )}
          </div>
        ))
      }
    </>
  )
}
